import cartService, { setActiveStorefrontTrackingContext } from "../services/cart.service";
import { attachStorefrontTrackingToCartItems } from "../../shared/checkout-tracking.js";
import { getProductPageSlotNo } from "../../shared/product-page-slot.js";
import { showCartAddError } from "../utils/cart-add-toast";

let bundleAddInflight = null;

export async function addProductPageBundleLineItems(
  popupData,
  getSelectedLineItems,
  {
    products = [],
    syncCartAfterAdd = true,
    // Only theme-ATC prepend (nested inside hybrid's cart/add patch) must bypass.
    // Claim Offer / standalone bundle adds must NOT bypass — otherwise the custom
    // cart drawer never opens (Jul 15 regression).
    bypassCartFetchPatch = false,
  } = {}
) {
  if (bundleAddInflight) return bundleAddInflight;

  const rawItems =
    typeof getSelectedLineItems === "function" ? getSelectedLineItems() : [];
  const lineItems = (rawItems || []).filter((item) => {
    if (item?.id == null || item.id === "") return false;
    const numeric = Number(item.id);
    return Number.isFinite(numeric) && numeric > 0;
  });
  if (!lineItems.length) {
    if (typeof console !== "undefined") {
      console.warn("[WeUpsell][ProductPageBundle][cart_add_skip_empty]", {
        rawItemCount: Array.isArray(rawItems) ? rawItems.length : 0,
        rawItems,
      });
    }
    return;
  }

  const items = lineItems.map(({ id, quantity }) => ({ id, quantity }));

  bundleAddInflight = (async () => {
    try {
      setActiveStorefrontTrackingContext({
        popup: popupData,
        shop: window?.Shopify?.shop || window.location.hostname,
        slotNo: getProductPageSlotNo(popupData),
      });

      const trackedItems = attachStorefrontTrackingToCartItems(items, {
        popup: popupData,
        shop: window?.Shopify?.shop || window.location.hostname,
        slotNo: getProductPageSlotNo(popupData),
        getProductForIndex: (index) => {
          const productIndex = lineItems[index]?.productIndex;
          return Number.isFinite(productIndex)
            ? products[productIndex]
            : products[index];
        },
      });

      // Widget ATC (bypass=false): suppress Modal-on-Cart-Add → drawer only.
      // Theme prepend (bypass=true): do NOT suppress — theme /cart/add must
      // still open Modal-on-Cart-Add after add-ons are prepended.
      const result = await cartService.addToCart(trackedItems, {
        attachTracking: false,
        syncCartAfterAdd,
        bypassCartFetchPatch,
        suppressModalOnCartAddRefire: !bypassCartFetchPatch,
      });
      if (typeof console !== "undefined") {
        console.log("[WeUpsell][ProductPageBundle][cart_add]", {
          itemCount: trackedItems.length,
          items: trackedItems,
          bypassCartFetchPatch,
          syncCartAfterAdd,
        });
      }
      return result;
    } catch (error) {
      console.error("[ProductPageBundleAdd] Failed to add selected upsell items:", error);
      showCartAddError(error);
      throw error;
    } finally {
      bundleAddInflight = null;
    }
  })();

  return bundleAddInflight;
}

/** @deprecated Hybrid fetch intercept owns add-to-cart; hook kept for API export only. */
export default function useProductPageBundleAddToCart() {
  return undefined;
}
